import BulletedText from '@/components/common/paragraphs/BulletedText'

export { BulletedText }
